<!-- 教师备授课教学行为分析 -->
<template>
    <div class="teach-behavior-analysis">
        <div class="teach-behavior-analysis-top">
            <div class="title">教师备授课教学行为分析</div>
            <div class="more" @click="goMore">更多 ></div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="teach-behavior-analysis-content">
            <div style="width:100%;height:100%;" :id="'chartsId'" v-show="!isShow"></div>
            <div class="chart-error" v-show="isShow">
                <div class="detail">
                    <span class="detail">暂无数据</span>
                </div>
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>
  
<script>
  import * as echarts from 'echarts';
  import { getTeaBehaviorAPI } from "@/service/api.js"
  export default {
    name: 'teach-behavior-analysis',
    components: {
    },
    props:{
        //请求参数
        params: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
            //是否展示缺省图，默认不展示缺醒图
            isShow:false,
            dateList:[],
            typeList:[],
            defaultPointList:[],
            pieData:[],
            smallPieColorArr: ["#0368E3", "#F36D81", "#7672ED"],
            bigPieColorArr: [
                "#2b7fff",
                "#27cde6",
                "#fdba01",
                "#ff7642",
                "#f35d76",
                "#a470eb",
                "#646bf6",
                "#43aaec",
                "#2b7fff",
                "#27cde6",
            ],
        }
    },
    watch:{
        params: {
            deep: true,
            handler (val) {
                this.getTeaBehavior();
            }
        }
    },
    methods: {
        goMore(){
            window.open(`https://jzjx.syjy.cn/databoard/areaschooldataboard?userId=${this.$store.getters.userId}&areaCode=330604&areaName=%E4%B8%8A%E8%99%9E%E5%8C%BA`,"_blank");
        },
        /**
         * 根据参数数组加载饼状图
         */
        copyParamData(list) {
        let _this = this;
        let _pieData = [];
        _this.defaultPointList = [];
        for (let i = 0; i < list.length; i++) {
            let pieItemObj = {};
            pieItemObj.name = list[i].sceneName;
            pieItemObj.value = list[i].count;
            pieItemObj.selected = false;
            pieItemObj.pointList = [];

            for (let j = 0; j < list[i].pointList.length; j++) {
            let pointObj = {};
            pointObj.name = list[i].pointList[j].displayName;
            pointObj.value = list[i].pointList[j].count;

            pieItemObj.pointList.push(pointObj);
            _this.defaultPointList.push(pointObj);
            }
            _pieData.push(pieItemObj);
        }
        return _pieData;
        },
        /**
         * @name 初始化图表
         */
        initEcharts(data){
            let _this = this;
            _this.pieData = _this.copyParamData(data);
            let dataSourcePie = this.$echarts.init(
                document.getElementById("chartsId")
            );
            let bigPieColorList = [];
            let smallPieColorList = [];
            for (let i = 0; i < _this.pieData.length; i++) {
                smallPieColorList.push(_this.smallPieColorArr[i]);
            }
            for (let i = 0; i < _this.defaultPointList.length; i++) {
                bigPieColorList.push(_this.bigPieColorArr[i]);
            }

            let fontSize = 12;
            let smallPieRadius = "40%";
            let bigPieRadiusStart = "55%";
            let bigPieRadiusEnd = "70%";
            let smallMinAngle = 5;
            let bigMinAngle = 10;
            fontSize = 9;
            smallMinAngle = 10;
            bigMinAngle = 18;
            
            const option = {
                tooltip: {
                    trigger: "item",
                    formatter: "{b}: {c} ({d}%)",
                },
                legend: {
                    data: [
                        '课前',
                        '课中',
                        '课后'
                    ],
                    left: 15,
                    itemWidth: 14, //图例标记的图形宽度
                    itemHeight: 14,
                    selectedMode: false,// 是否允许点击
                    textStyle: {
                        color: []
                    },
                },
                series: [
                {
                    name: "",
                    type: "pie",
                    minAngle: smallMinAngle, //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                    avoidLabelOverlap: true, //是否启用防止标签重叠策略
                    selectedMode: "single",
                    radius: [0, smallPieRadius],
                    center: ["50%", "60%"], // 图的位置
                    label: {
                    normal: {
                        position: "inner",
                        fontSize: fontSize,
                    },
                    },
                    labelLine: {
                    normal: {
                        show: false,
                    },
                    },
                    data: _this.pieData,
                    // color: ["#4180FF", "#018AE6", "#03C4B0"],
                    color: ["#0368E3", "#F36D81", "#7672ED"],
                },
                {
                    name: "",
                    type: "pie",
                    minAngle: bigMinAngle, //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                    avoidLabelOverlap: true, //是否启用防止标签重叠策略
                    radius: [bigPieRadiusStart, bigPieRadiusEnd],
                    center: ["50%", "60%"], // 图的位置
                    label: {
                    normal: {
                        formatter: "{b}",
                        fontSize: fontSize,
                    },
                    },
                    labelLine: {
                    normal: {
                        length: 12,
                        length2: 12,
                    },
                    },
                    data: _this.defaultPointList,
                    color: bigPieColorList,
                },
                ],
            };
            dataSourcePie.clear();
            let isNotMerge = true;
            option.series[0].data[0].selected = true;
            this.legendIndex = option.series[0].data[0].name;
            option.series[1].data = option.series[0].data[0].pointList;
            dataSourcePie.setOption(option, true);
            // 处理点击事件
            dataSourcePie.on("click", function (params) {
                if (params.seriesIndex == 0) {
                for (var i = 0; i < option.series[0].data.length; i++) {
                    option.series[0].data[i].selected = false;
                }
                option.series[0].data[params.dataIndex].selected = true;
                _this.legendIndex = option.series[0].data[params.dataIndex].name;
                option.series[1].data =
                    option.series[0].data[params.dataIndex].pointList;
                dataSourcePie.clear();
                dataSourcePie.setOption(option);
                }
            });
            window.addEventListener("resize", function () {
                dataSourcePie.resize();
            });
            // let chartDom = document.getElementById('chartsId');
            // let myChart = echarts.init(chartDom);
            // let option;
            // let typeList = this.typeList.map((item,index)=>{
            //     item.label= {
            //         show: index < 5
            //     }
            //     item.labelLine= {
            //         show: index < 5
            //     }
            //     return item
            // })

            // option = {
            //     tooltip: {
            //         trigger: 'item',
            //     },
            //     legend: {
            //         data: [
            //             '课前',
            //             '课中',
            //             '课后'
            //         ],
            //         left: 15,
            //         itemWidth: 14, //图例标记的图形宽度
            //         itemHeight: 14,
            //         selectedMode: false,// 是否允许点击
            //         textStyle: {
            //             color: []
            //         },
            //     },
            //     series: [
            //         {
            //             name,
            //             type: 'pie',
            //             selectedMode: 'single',
            //             radius: [0, '30%'],
            //             center: ['50%', '65%'],
            //             color:['#43AAEC','#A470EB','#646BF6'],
            //             label: {
            //                 position: 'inner',
            //                 fontSize: 14
            //             },
            //             labelLine: {
            //                 show: false
            //             },
            //             data:this.dateList,
            //         },
            //         {
            //             name,
            //             type: 'pie',
            //             radius: ['45%', '60%'],
            //             center: ['50%', '65%'],
            //             color: ['#2B7FFF','#27CDE6','#FDBA01','#FF7642','#F35D76','#A470EB','#646BF6','#43AAEC'],
            //             labelLine: {
            //                 show: false //数据标签引导线
            //             },
            //             label: {
            //                 lineHeight: 20,
            //                 align: 'center',
            //                 textStyle: {
            //                     rich: {
            //                         name: {
            //                             fontSize: 14,
            //                             color: '#303133'
            //                         },
            //                         percent: {
            //                             fontSize: 14,
            //                             color: '#909399'
            //                         }
            //                     }
            //                 },
            //                 formatter: (param) => {
            //                     return param.name
            //                 }
            //             },
            //             data:typeList
            //         }
            //     ]
            // };

            // option && myChart.setOption(option);
        },
        /**
         * @name 获取教师备授课教学行为分析
         */
        getTeaBehavior(){
            getTeaBehaviorAPI({...this.params}).then((res)=>{
                let list = JSON.parse(res)
                // this.dateList = [];
                // this.typeList = [];
                // list.forEach((item)=>{
                //     this.dateList.push({
                //         value: item.count,
                //         name: item.sceneName
                //     })
                //     let dataList = item.pointList.map((sitem)=>{
                //         return {
                //             value: sitem.count,
                //             name: sitem.displayName
                //         }
                //     })
                //     this.typeList = this.typeList.concat(dataList)
                // })
                // this.typeList.sort((a,b)=>{
                //     return b.value-a.value
                // })
                this.initEcharts(list);
            }).catch((err)=>{
                this.$Message.error('教师备授课教学行为分析获取失败！');
            })
        }
    },
    mounted(){
        // //初始化图表
        // this.initEcharts();
        //获取教师备授课教学行为分析
        this.getTeaBehavior();
    },
  }
</script>
  
<style lang="scss" scoped>
.teach-behavior-analysis{
    width: 100%;
    height: 390px;
    padding: 0 15px;
    border: 1px solid #053882;
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    .teach-behavior-analysis-top{
        position: relative;
        text-align: center;
        margin-bottom: 20px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .teach-behavior-analysis-content{
        width: 100%;
        height: 325px;
    }
    .top-left{
        position: absolute;
        top: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
}
</style>
<style lang="scss">
</style>